var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClick1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.38853 7.42697L5.819 5.84356M15.7583 7.42697L17.3278 5.84356M5.81793 17.4602L7.38746 15.8757M11.5729 5.31611V3.20312M5.29476 11.6519H3.20312M18.0175 17.9759L22.0898 16.3679C22.188 16.3286 22.2722 16.2608 22.3316 16.1731C22.3909 16.0855 22.4226 15.9821 22.4226 15.8763C22.4226 15.7704 22.3909 15.667 22.3316 15.5794C22.2722 15.4917 22.188 15.4239 22.0898 15.3846L12.3042 11.5248C12.209 11.488 12.105 11.4797 12.0051 11.501C11.9052 11.5223 11.8137 11.5722 11.7417 11.6447C11.6698 11.7172 11.6206 11.8092 11.6 11.9092C11.5795 12.0093 11.5886 12.1132 11.6262 12.2081L15.4508 22.0855C15.6237 22.5339 16.2515 22.5339 16.4245 22.0855L18.0175 17.9759Z",
    stroke: "#919090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClick1);
export default __webpack_public_path__ + "static/media/click1.2d3871763ecda3c9ff1664f7e0e67131.svg";
export { ForwardRef as ReactComponent };